import { ReceiptText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';

import PartyTabSection from '@/components/common/PartyTabSection';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import { PARTY_TAB_SECTIONS_MAX_ITEMS } from '@/features/party/constants';
import paths from '@/lib/paths';
import { todayShort } from '@/lib/utils/date';
import useLocalSettings from '@/stores/useLocalSettings';

import useInvoices from '../../queries/hooks/useInvoices';

import InvoiceItem from './InvoiceItem';

export default function InvoicesSection() {
  const { t } = useTranslation();

  const { onlyShowRelevant } = useLocalSettings();

  const party = useSelectedParty();
  const {
    analysis: {
      relevant: { invoiceIds },
    },
  } = useEmail();

  const { data: invoices, isLoading } = useInvoices(
    party?.id ?? '',
    { status: ['OPEN', 'PARTIALLY_PAID'], from: todayShort() },
    {
      enabled: Boolean(party?.id),
    },
  );

  const shownItems = onlyShowRelevant
    ? invoices?.filter((invoice) => invoiceIds?.includes(invoice.id))
    : invoices?.slice(0, PARTY_TAB_SECTIONS_MAX_ITEMS);

  return (
    <PartyTabSection
      icon={ReceiptText}
      title={t('INVOICES_OVERDUE')}
      noItemsMessage={t('INVOICES_NONE_OPEN')}
      more={`${generatePath(paths.invoices.overview)}?outstanding=true`}
      isLoading={isLoading}
      totalItems={invoices?.length ?? 0}
      relevantItems={invoiceIds?.length ?? 0}
    >
      {shownItems?.map((invoice) => (
        <InvoiceItem key={invoice.id} invoice={invoice} />
      ))}
    </PartyTabSection>
  );
}
